import { Component, Input, OnInit } from '@angular/core';
import { DragListCustomSettings } from 'src/app/common-modules/shared/core/drag-list-custom/drag-list-custom-settings';
import { MapLegendItems } from '../models/map-legend.items';

const COMPONENT_SELECTOR = 'ct-map-legend-items';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './map-legend-items.component.html',
  styleUrl: './map-legend-items.component.scss',
  standalone: false,
})
export class MapLegendItemsComponent implements OnInit {
  @Input() mapLegendItems: MapLegendItems[];

  settingsCustom: DragListCustomSettings;

  ngOnInit(): void {
    this.settingsCustom = new DragListCustomSettings({
      hideFilter: true,
      emptyLegendKey: '',
      isReadOnly: false,
    });
  }
}
